import { StyleSheet, TouchableOpacity } from "react-native";

import { Text, View } from "../components/Themed";

export default function NotFoundScreen({
  navigation,
}) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>wasted</Text>
      <TouchableOpacity
        onPress={() => navigation.replace("Root")}
        style={styles.link}
      >
        <Text style={styles.linkText}>Try again</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    fontFamily: "Pricedown-Bl",
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    fontFamily: "Pricedown-Bl",
    color: "#2e78b7",
  },
});
